import { apiClient } from './api'

export type ProgramStatus = 'planning' | 'active' | 'on_hold' | 'completed' | 'archived'

export interface Program {
  id: number
  name: string
  description: string | null
  status: ProgramStatus
  organization_id: number | null
  portfolio_id: number | null
  owner_id: number | null
  start_date: string | null
  end_date: string | null
  metadata?: Record<string, unknown>
  created_at: string
  updated_at: string
}

export interface ProgramCreate {
  name: string
  description?: string
  status?: ProgramStatus
  start_date?: string
  end_date?: string
  owner_id?: number
  portfolio_id?: number
  organization_id?: number
  metadata?: Record<string, unknown>
}

export interface ProgramUpdate {
  name?: string
  description?: string
  status?: ProgramStatus
  start_date?: string
  end_date?: string
  owner_id?: number
  portfolio_id?: number
  metadata?: Record<string, unknown>
}

export const programsService = {
  /**
   * List programs
   */
  async list(params?: { skip?: number; limit?: number; status?: string; portfolio_id?: number; include_deleted?: boolean }): Promise<Program[]> {
    const response = await apiClient.get<Program[]>('/api/v1/programs', { params })
    return response.data
  },

  /**
   * Get program by ID
   */
  async get(id: number): Promise<Program> {
    const response = await apiClient.get<Program>(`/api/v1/programs/${id}`)
    return response.data
  },

  /**
   * Create program
   */
  async create(data: ProgramCreate): Promise<Program> {
    const response = await apiClient.post<Program>('/api/v1/programs', data)
    return response.data
  },

  /**
   * Update program
   */
  async update(id: number, data: ProgramUpdate): Promise<Program> {
    const response = await apiClient.put<Program>(`/api/v1/programs/${id}`, data)
    return response.data
  },

  /**
   * Delete program
   */
  async delete(id: number): Promise<void> {
    await apiClient.delete(`/api/v1/programs/${id}`)
  },

  /**
   * Restore program
   */
  async restore(id: number): Promise<Program> {
    const response = await apiClient.post<Program>(`/api/v1/programs/${id}/restore`)
    return response.data
  },
}

